(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csb-amazon"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('csb-amazon-markets')){
  customElements.define('csb-amazon-markets',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      const primary=this.querySelector('[data-amazon-primary]');
      const label=this.querySelector('[data-amazon-label]');
      this.addEventListener('change',event=>{
        const option=event.target;
        if(!option.matches('input[type="radio"][data-url]'))return;
        primary.href=option.dataset.url;
        label.textContent=option.dataset.label;
      });
      this.querySelector('[data-amazon-countries]').hidden=false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csb-conference"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('csb-conference-gallery')) {
  customElements.define('csb-conference-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      if (!this.track || !this.slides.length || this.abort) return;
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-count]');
      this.progress = this.querySelector('[data-gallery-progress]');
      this.status = this.querySelector('[data-gallery-status]');
      this.statusTemplate = this.querySelector('[data-gallery-status-template]').content.textContent;
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.goTo(0);
        else if (event.key === 'End') this.goTo(this.slides.length - 1);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.update();
          this.frame = 0;
        });
      }, { passive:true, signal:this.abort.signal });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }
    measurements() {
      const width = this.slides[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = width + gap;
      const visible = Math.max(1, Math.round((this.track.clientWidth + gap) / step));
      const index = Math.min(this.slides.length - visible, Math.max(0, Math.round(this.track.scrollLeft / step)));
      return { step,visible,index };
    }
    move(direction) {
      const { index,visible } = this.measurements();
      this.goTo(index + direction * visible);
    }
    goTo(index) {
      const { step,visible } = this.measurements();
      const target = Math.max(0,Math.min(this.slides.length - visible,index));
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left:target * step, behavior });
    }
    update() {
      const { index,visible } = this.measurements();
      const maximum = this.slides.length - visible;
      this.previous.disabled = index === 0;
      this.next.disabled = index >= maximum;
      this.counter.textContent = `${String(index + 1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
      this.progress.style.width = `${visible / this.slides.length * 100}%`;
      this.progress.style.setProperty('--csb-gallery-position',`${index / visible * 100}%`);
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        this.status.textContent = this.statusTemplate.replace('[number]',String(index + 1));
      }, 220);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.announceTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csb-story"] && !Shopify.designMode) return;
  try {
    
function csbBindVideo(root){root.querySelectorAll('[data-csb-video]').forEach((wrap)=>{const button=wrap.querySelector('button');if(!button||button.dataset.ready)return;button.dataset.ready='true';button.addEventListener('click',()=>{const id=wrap.dataset.csbVideo;if(!id)return;const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&rel=0';frame.title=wrap.dataset.csbTitle;frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;wrap.replaceChildren(frame);});});}csbBindVideo(document);document.addEventListener('shopify:section:load',(event)=>csbBindVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csb-why-steel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('csb-steel-story')) {
  customElements.define('csb-steel-story', class extends HTMLElement {
    connectedCallback() {
      this.frame = 0;
      this.playFrame = 0;
      this.activePlay = null;
      this.chapters = Array.from(this.querySelectorAll('.steel-chapter'));
      this.motionButton = this.querySelector('.steel-motion');
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.compact = window.matchMedia('(max-width: 989px), (max-height: 650px)');
      this.manualStatic = false;this.loopFrame=0;this.coffeeElapsed=0;this.stepFrame=0;
      this.states = [];
      this.chapters.forEach((chapter, order) => {
        const index = Number(chapter.dataset.storyChapter) - 1;
        this.states[index] = {
        chapter, index, progress: 1, manual: null,
        window: chapter.querySelector('.steel-photo-window'),
        frame: chapter.querySelector('.steel-frame'),
        scene: chapter.querySelector('csb-steel-product-scene'),
        controls: chapter.querySelector('.steel-controls'),
        slider: chapter.querySelector('input[type="range"]'),
        play: chapter.querySelector('[data-steel-play]'),
        follow: chapter.querySelector('[data-steel-follow]')
        };
      });
      this.queue = () => {
        if (this.frame || !this.classList.contains('is-animated')) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
      };
      this.applyMode = () => {
        this.stopPlayback();this.stopStep();this.stopLoop();
        const reduced = this.manualStatic || this.preference.matches;
        this.classList.toggle('is-animated', !reduced);
        this.motionButton.setAttribute('aria-pressed', String(reduced));
        this.states.forEach(state => {
          state.manual = null;
          if (state.controls) state.controls.hidden = reduced;
          this.setProgress(state, state.index===1||state.index===2?0:1);
        });
        this.states[1].window.style.opacity='1';this.querySelector('csb-steel-paper-scenes')?.setTime?.(reduced?2200:this.coffeeElapsed);this.querySelector('csb-steel-hero-loop')?.setPaused?.(reduced);
        this.querySelectorAll('csb-engraving-trial, csb-steel-torch').forEach(demo=>demo.setPaused?.(reduced));
        this.syncLoop();this.queue();
      };
      this.toggleMode = () => { this.manualStatic = !this.manualStatic; this.applyMode(); };
      this.motionButton.hidden = this.preference.matches;
      this.motionButton.addEventListener('click', this.toggleMode);
      this.preferenceChange = () => { this.motionButton.hidden = this.preference.matches; this.applyMode(); };
      this.preference.addEventListener('change', this.preferenceChange);
      this.compact.addEventListener('change', this.applyMode);
      this.states.forEach(state => {
        if (!state.controls) return;
        state.onInput = () => {
          this.stopPlayback();
          state.manual = Number(state.slider.value) / 1000;
          this.setProgress(state, state.manual);
        };
        state.onFollow = () => { this.stopPlayback(); state.manual = null; this.queue(); };
        state.onPlay = () => {
          if (this.activePlay === state) { this.stopPlayback(); return; }
          this.stopPlayback();
          state.manual = state.progress >= .995 ? 0 : state.progress;
          this.activePlay = state;
          this.playStart = null;
          this.playFrom = state.manual;
          state.play.textContent = state.play.dataset.pause;
          state.play.setAttribute('aria-pressed', 'true');
          this.playFrame = requestAnimationFrame(this.tick);
        };
        state.slider.addEventListener('input', state.onInput);
        state.follow.addEventListener('click', state.onFollow);
        state.play.addEventListener('click', state.onPlay);
      });
      this.tick = time => {
        this.playFrame = 0;
        const state = this.activePlay;
        if (!state) return;
        const box = state.window.getBoundingClientRect();
        if (document.hidden || box.bottom < 0 || box.top > window.innerHeight || !this.classList.contains('is-animated')) { this.stopPlayback(); return; }
        if (this.playStart === null) this.playStart = time;
        // Give the pen time to follow the real stencil geometry letter by letter.
        const duration = state.index === 3 ? 55000 : state.index === 2 ? 12000 : 6500;
        state.manual = Math.min(1, this.playFrom + (time - this.playStart) / duration);
        this.setProgress(state, state.manual);
        if (state.manual >= 1) this.stopPlayback();
        else this.playFrame = requestAnimationFrame(this.tick);
      };
      this.onVisibility = () => { if (document.hidden) { this.stopPlayback();this.stopStep(); }this.stopLoop();this.syncLoop(); };
      this.setupSteps();
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('scroll', this.queue, { passive: true });
      window.addEventListener('resize', this.queue, { passive: true });
      this.applyMode();
      // The shared homepage renderer may be defined by a deferred asset after this section.
      const generation = this.generation = (this.generation || 0) + 1;
      customElements.whenDefined('csb-steel-paper-scenes').then(()=>{if(this.isConnected&&generation===this.generation)this.querySelector('csb-steel-paper-scenes')?.setTime?.(this.manualStatic||this.preference.matches?2200:this.coffeeElapsed);});
      customElements.whenDefined('csb-steel-torch').then(()=>{if(this.isConnected&&generation===this.generation)this.querySelector('csb-steel-torch')?.setPaused?.(this.manualStatic||this.preference.matches);});
      customElements.whenDefined('csb-steel-hero-loop').then(()=>{if(this.isConnected&&generation===this.generation)this.querySelector('csb-steel-hero-loop')?.setPaused?.(this.manualStatic||this.preference.matches);});
      customElements.whenDefined('csb-steel-product-scene').then(() => {
        if (this.isConnected && generation === this.generation) {this.states.forEach(state => this.setProgress(state, state.progress));this.querySelector('csb-steel-hero-loop')?.setPaused?.(this.manualStatic||this.preference.matches);}
      });
    }
    setProgress(state, value) {
      const clamp = number => Math.min(1, Math.max(0, number));
      state.progress = clamp(value);
      state.chapter.style.setProperty('--p', state.progress.toFixed(4));
      state.chapter.style.setProperty('--spill', clamp((state.progress - .12) / .65).toFixed(4));
      state.chapter.style.setProperty('--trace', clamp((state.progress - .08) / .8).toFixed(4));
      if (state.slider) state.slider.value = String(Math.round(state.progress * 1000));
      if (typeof state.scene?.setProgress === 'function') {
        const progress = state.index===3 ? (state.stepValue??3.56/8) : state.index === 2 ? state.progress
          : state.progress < .65 ? .4325 + (state.progress / .65) * .0825
          : .515 + ((state.progress - .65) / .35) * .022;
        state.scene.setProgress(progress);
      }
    }
    paint() {
      if (!this.classList.contains('is-animated')) return;
      this.states.forEach(state => {
        const box = state.chapter.getBoundingClientRect();
        const photo = state.window.getBoundingClientRect();
        const visible = photo.bottom > 0 && photo.top < window.innerHeight;
        state.chapter.classList.toggle('is-inview', visible);
        if (!visible && this.activePlay === state) this.stopPlayback();
        if(state.index===1){this.syncLoop();return;}
        if(state.index===3)return;
        if (state.index === 0 || state.index >= 4) { this.setProgress(state, 1); return; }
        if (state.manual !== null) return;
        const progress = this.compact.matches
          ? (window.innerHeight - photo.top - photo.height * .15) / Math.max(1, window.innerHeight * .75)
          : -box.top / Math.max(1, box.height - state.frame.offsetHeight);
        this.setProgress(state, progress);
      });
    }
    setupSteps() {
      const state=this.states[3];this.stepIndex=0;state.stepValue=3.56/8;
      this.stepPanel=state.chapter.querySelector('.steel-pen-steps');this.stepPanel.hidden=false;
      this.nextStep=this.stepPanel.querySelector('[data-step-next]');this.backStep=this.stepPanel.querySelector('[data-step-back]');
      this.stepStatus=this.stepPanel.querySelector('[data-step-status]');this.stepCopy=this.stepPanel.querySelector('[data-step-copy]');
      this.onNextStep=()=>this.goStep(this.stepIndex===3?0:this.stepIndex+1);
      this.onBackStep=()=>this.goStep(Math.max(0,this.stepIndex-1));
      this.nextStep.addEventListener('click',this.onNextStep);this.backStep.addEventListener('click',this.onBackStep);
    }
    centerPenImage() {
      const box=this.states[3].window.getBoundingClientRect();
      const viewport=window.visualViewport,height=viewport?.height||window.innerHeight;
      const header=document.querySelector('sticky-header');
      const inset=header?Math.min(header.getBoundingClientRect().height,height/3):0;
      const top=(viewport?.offsetTop||0)+inset+Math.max(16,(height-inset-box.height)/2);
      window.scrollTo({top:Math.max(0,window.scrollY+box.top-top),behavior:this.preference.matches?'instant':'smooth'});
    }
    goStep(index) {
      this.stopStep();const state=this.states[3],from=state.stepValue,targets=[3.56/8,3.715/8,3.965/8,4.065/8];
      this.stepIndex=index;this.nextStep.textContent=index===3?this.nextStep.dataset.restart:this.nextStep.dataset.next;
      this.backStep.disabled=index===0;this.stepStatus.textContent=index?this.stepCopy.dataset['step'+index]:this.stepCopy.dataset.intro;
      this.centerPenImage();
      const to=targets[index],duration=2400;this.stepTarget=to;
      if(this.preference.matches||this.manualStatic||index===0){state.stepValue=to;this.setProgress(state,1);return;}
      this.nextStep.disabled=true;let start=null,waitingSince=null;
      const tick=time=>{this.stepFrame=0;const box=state.window.getBoundingClientRect();
        if(waitingSince===null)waitingSince=time;
        if(!document.hidden&&start===null&&(box.bottom<=0||box.top>=window.innerHeight)&&time-waitingSince<1000){this.stepFrame=requestAnimationFrame(tick);return;}
        if(document.hidden||box.bottom<=0||box.top>=window.innerHeight){state.stepValue=to;this.setProgress(state,1);this.nextStep.disabled=false;return;}
        if(start===null)start=time;const p=Math.min(1,(time-start)/duration);state.stepValue=from+(to-from)*p;this.setProgress(state,1);
        if(p<1)this.stepFrame=requestAnimationFrame(tick);else this.nextStep.disabled=false;
      };this.stepFrame=requestAnimationFrame(tick);
    }
    stopStep(){if(this.stepFrame&&this.states?.[3]&&this.stepTarget!==undefined){this.states[3].stepValue=this.stepTarget;this.setProgress(this.states[3],1);}cancelAnimationFrame(this.stepFrame);this.stepFrame=0;if(this.nextStep)this.nextStep.disabled=false;}
    stopLoop(){cancelAnimationFrame(this.loopFrame);this.loopFrame=0;this.loopLast=null;}
    syncLoop(){
      const state=this.states[1],box=state.window.getBoundingClientRect();
      if(document.hidden||!this.classList.contains('is-animated')||box.bottom<=0||box.top>=window.innerHeight){this.stopLoop();return;}
      if(this.loopFrame)return;
      const tick=time=>{this.loopFrame=0;const rect=state.window.getBoundingClientRect();if(document.hidden||!this.classList.contains('is-animated')||rect.bottom<=0||rect.top>=window.innerHeight){this.stopLoop();return;}
        const delta=this.loopLast===null?0:Math.min(80,Math.max(0,time-this.loopLast));this.loopLast=time;
        this.coffeeElapsed=(this.coffeeElapsed+delta)%19700;
        state.chapter.querySelector('csb-steel-paper-scenes')?.setTime?.(this.coffeeElapsed);
        this.loopFrame=requestAnimationFrame(tick);
      };this.loopFrame=requestAnimationFrame(tick);
    }
    stopPlayback() {
      cancelAnimationFrame(this.playFrame);
      this.playFrame = 0;
      if (this.activePlay) {
        this.activePlay.play.textContent = this.activePlay.play.dataset.play;
        this.activePlay.play.setAttribute('aria-pressed', 'false');
      }
      this.activePlay = null;
    }
    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.stopPlayback();this.stopLoop();this.stopStep();
      this.nextStep?.removeEventListener('click',this.onNextStep);this.backStep?.removeEventListener('click',this.onBackStep);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      window.removeEventListener('scroll', this.queue);
      window.removeEventListener('resize', this.queue);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.preference?.removeEventListener('change', this.preferenceChange);
      this.compact?.removeEventListener('change', this.applyMode);
      this.motionButton?.removeEventListener('click', this.toggleMode);
      this.states?.forEach(state => {
        state.slider?.removeEventListener('input', state.onInput);
        state.follow?.removeEventListener('click', state.onFollow);
        state.play?.removeEventListener('click', state.onPlay);
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.mobileViewport = window.matchMedia('(max-width: 989px)');
      this.isCsbTheme = document.body.classList.contains('csb-theme');
      this.onViewportChange = this.configurePersistentHeader.bind(this);
      this.mobileViewport.addEventListener('change', this.onViewportChange);
      this.headerResizeObserver = new ResizeObserver(() => this.updateHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        if (!this.persistentHeader) this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.configurePersistentHeader();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileViewport.removeEventListener('change', this.onViewportChange);
      this.headerResizeObserver.disconnect();
      this.boundsObserver?.disconnect();
      window.clearTimeout(this.isScrolling);
      if (this.isCsbTheme) {
        document.documentElement.style.setProperty('--csb-header-height', '0px');
        window.dispatchEvent(new CustomEvent('csb:header-resize', { detail: { height: 0 } }));
      }
    }

    configurePersistentHeader() {
      this.persistentHeader = this.isCsbTheme;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      window.clearTimeout(this.isScrolling);
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.updateHeaderHeight();
      this.createObserver();
    }

    updateHeaderHeight() {
      if (!this.isCsbTheme || !this.isConnected) return;
      const height = this.persistentHeader ? Math.ceil(this.header.getBoundingClientRect().height) : 0;
      if (height === this.publishedHeaderHeight) return;
      this.publishedHeaderHeight = height;
      document.documentElement.style.setProperty('--csb-header-height', `${height}px`);
      window.dispatchEvent(new CustomEvent('csb:header-resize', { detail: { height } }));
    }

    createObserver() {
      this.boundsObserver?.disconnect();
      this.boundsObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.boundsObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.persistentHeader) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.persistentHeader || !this.isConnected) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.persistentHeader || !this.isConnected) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
